import * as Yup from 'yup';

export const emailTemplateSchema = Yup.object().shape({

    name: Yup.string().required("Please enter name"),
    templateId: Yup.string().required("Please enter template id")
    
})
